import LetterGrid from './containers/LetterGrid/LetterGrid';

import './App.css';

function App() {
  return (
    <div className="App">
      <LetterGrid />
    </div>
  );
}

export default App;
